import { Link } from "react-router-dom";
import { BELogo } from "./BELogo";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { waLink } from "../lib/wa";

export const Footer = () => {
  return (
    <footer
      className="bg-[#0a0a0c] text-[#f5f5f7] pt-24 pb-10 relative overflow-hidden"
      data-testid="site-footer"
    >
      <div className="grain" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="pb-14 border-b border-white/10">
          <div className="h1-hero text-[18vw] md:text-[14vw] leading-[0.85] text-white/95">
            BHUMI.
          </div>
          <div className="mt-4 flex flex-wrap items-center gap-4 text-white/50 text-sm">
            <span>Authorised Dealer of Bobcat India</span>
            <span className="w-1 h-1 bg-white/30 rounded-full" />
            <span>Pan-India service support · HQ Panvel, Maharashtra</span>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-10 mt-14">
          <div>
            <BELogo size={44} variant="white" />
            <p className="mt-6 text-sm text-white/60 max-w-xs leading-relaxed">
              Moving earth. Building India. From Panvel to Dhule — wherever the
              work is, we're already there.
            </p>
          </div>

          <div>
            <div className="overline text-[#ff6a13] mb-4">Model Lineup</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/models?category=Skid-Steer Loaders" className="hover:text-[#ff6a13]">Skid-Steer Loaders</Link></li>
              <li><Link to="/models?category=Compact Track Loaders" className="hover:text-[#ff6a13]">Compact Track Loaders</Link></li>
              <li><Link to="/models?category=Backhoe Loaders" className="hover:text-[#ff6a13]">Backhoe Loaders</Link></li>
              <li><Link to="/models?category=Mini Excavators" className="hover:text-[#ff6a13]">Mini Excavators</Link></li>
              <li><Link to="/attachments" className="hover:text-[#ff6a13]">Attachments</Link></li>
              <li><Link to="/parts-service" className="hover:text-[#ff6a13]">Parts & Service</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-[#ff6a13] mb-4">Connect</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <MessageCircle size={16} className="mt-0.5 text-[#ff6a13]" />
                <a href={waLink({ source: "footer" })} target="_blank" rel="noreferrer" className="hover:text-[#ff6a13]" data-testid="footer-whatsapp-link">
                  +91 91676 32596
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 text-[#ff6a13]" />
                <a href="mailto:info@bhumiequipments.com" className="hover:text-[#ff6a13]">info@bhumiequipments.com</a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 text-[#ff6a13]" />
                <a href="tel:+919167632596" className="hover:text-[#ff6a13]">+91 91676 32596</a>
              </li>
            </ul>
          </div>

          <div>
            <div className="overline text-[#ff6a13] mb-4">Head Office</div>
            <p className="text-sm text-white/80 leading-relaxed flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 text-[#ff6a13] shrink-0" />
              <span>#13, Ground Floor, National Paradise, Plot No. 290/1, Takka, Panvel – 410 206</span>
            </p>
            <Link to="/admin/login" className="inline-block mt-6 text-xs text-white/40 hover:text-white" data-testid="footer-admin-link">
              Dealer Portal →
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Bhumi Equipments. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Authorised Dealer · Bobcat®</span>
            <span className="italic font-bold tracking-tight">One Tough Animal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
